var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"normalToastRoot"}},[_c('div',{style:({'background':_vm.$store.state.baseColor}),attrs:{"id":"normalToastContainer"}},[_c('div',{attrs:{"id":"normalToastMessageTagParent"}},[_c('label',[_vm._v(_vm._s(_vm.$store.state.toastMessage))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c540ab4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Normal/Toast.vue
// module id = null
// module chunks = 